export const isdirty_success = (data) => ({
  type: "ISDIRTY_SUCCESS",
  data,
});
